import React, { useState } from 'react'
import { Button, Checkbox } from '../../../components'
import { useSelector } from 'react-redux'
import { ID } from '../../../utils'
import { toast } from 'react-toastify'
import GuestRow from './guest-form-row'
import { OccupationProvider } from '../../../features/occupation/hook/provider'
import dayjs from 'dayjs'
import apiService from '../../../features/api/service'
import { useInternationalization } from '../../../features/i18n'
import { SystemProvider } from '../../../features/system/provider'

const GuestForm = ({setStep, setSummaryData}) => {
  const [requesting, setRequesting] = useState(false)
  const [isAgreed, setIsAgreed] = useState(false)
  const [guests, setGuests] = useState([generateNewGuest()])
  const data = useSelector(state => state.event.data)
  const myId = useSelector(state => state.account.profile.id)
  const { translate } = useInternationalization()

  const {
    pkActivityOrganizingId
  } = data

  const handleAdd = () => {
    setGuests([
      ...guests,
      generateNewGuest()
    ])
  }

  const isValid = () => {
    let result = true

    for (let index = 0; index < guests.length; index++) {
      const element = guests[index];
      if(!element.isSelf && !element.email){
        result = false
      }
    }

    return result
  }

  const handleSubmit = (e) => {
    if(e && e.preventDefault){
      e.preventDefault()
    }

    if(isValid()){
      console.log({guests, pkActivityOrganizingId})

      if(pkActivityOrganizingId && myId){
        const cloned = [...guests.filter(g => g.name && g.name !== "")]
        const requestBody = {}

        if(guests[0] && guests[0].isSelf){
          const activityParticipantInternal = {
            "nomorTiket": dayjs().format('YYYYMMDD')+ID(),
            "kehadiran": 1,
            "preferedNotification": 1,
            "feedback": "N/A",
            "opsiSatisfaction": 0
          }

          requestBody.activityParticipantInternal = activityParticipantInternal
          cloned.shift()
        }

        const activityParticipantEksternal = cloned.map(guest => (
          {
            "userYangMendaftarkan": myId,
            "nomorTiket": dayjs().format('YYYYMMDD')+ID(),
            "nama": guest.name,
            "pekerjaan": typeof guest.occupation === 'string' ? guest.occupation : guest.occupation ? guest.occupation.value : 'Other',
            "telepon": guest.phone ? guest.phone : 'N/A',
            "email": guest.email,
            "typeGender": guest.gender ? guest.gender.value : 1,
            "typeDifable": guest.disability ? guest.disability.value : 1,
            "kehadiran": 1,
            "preferedNotification": 1,
            "opsiSatisfaction": 0,
            "feedback": "N/A"
          }
        ))

        if(activityParticipantEksternal.length > 0){
          requestBody.activityParticipantEksternal = activityParticipantEksternal
        }

        console.log({requestBody})

        setRequesting(true)

        apiService.update('events_extension', pkActivityOrganizingId, requestBody)
          .then(res => {
            console.log({res})
            setStep('summary')
            setSummaryData({
              event: data,
              guests,
            })
          })
          .catch(err => {
            console.log({err})
            toast.error('error')
          })
          .finally(() => setRequesting(false))
      } else {
        toast.error('Error 400: no id provided.')
      }
    } else {
      toast.error('Invalid form.')
    }
  }

  const handleChange = (index, e) => {
    if(e.target && e.target !== null){
      const cloned = [...guests]

      cloned[index][e.target.name] = e.target.value

      setGuests(cloned)
    }
  }

  const isDisabled = !isAgreed || requesting

  const handleCheckbox = e => {
    if(e.target && e.target !== null){
      setIsAgreed(e.target.checked)
    }
  }

  const handleDelete = (id) => {
    if(id){
      const cloned = [...guests]
      const result = cloned.filter(c => c.id !== id)

      setGuests(result)
    }
  }

  return <>
    <form onSubmit={handleSubmit}>
      <SystemProvider>
        <OccupationProvider>
          {
            guests.map((guest, index) => (
              <div key={guest.id}>
                <GuestRow
                  isFirst={index === 0}
                  number={String(index+1)}
                  onChange={e => handleChange(index, e)}
                  onDelete={() => handleDelete(guest.id)}
                />

                <hr className="my-8 lg:my-10"/>
              </div>
            ))
          }
        </OccupationProvider>
      </SystemProvider>

      <div className="mb-8 lg:mb-10 text-center">
        <p
          className="link font-medium lg:text-lg cursor-pointer"
          onClick={handleAdd}
        >
          + {translate('EVENT', 'add_more_guest')}
        </p>
      </div>

      <div className="mb-8 lg:mb-10">
        <div className="flex lg:block">
          <Checkbox
            label={translate('EVENT', 'tnc')}
            onChange={e => {e.persist(); handleCheckbox(e)}}
            checked={isAgreed}
            style={{width: '15px', height: '15px'}}
            width="15"
            height="15"
            id="agree"
          />
          {/* <input
            type="checkbox"
            id="agree"
            className="block lg:inline mt-1 lg:mt-0 mr-2 cursor-pointer"
            onChange={handleCheckbox}
            checked={isAgreed}
            width="15"
            height="15"
            style={{width: '15px', height: '15px'}}
          />
          <label htmlFor="agree" className="block lg:inline text-sm text-gray-444 cursor-pointer">
            {translate('EVENT', 'tnc')}
          </label> */}
        </div>
      </div>

      <div className="flex justify-end mb-8 lg:mb-0">
        <Button
          className="inline-block w-full lg:w-auto"
          style={{minWidth: '170px'}}
          disabled={isDisabled}
          isLoading={requesting}
        >
          {translate('GENERAL', 'submit')}
        </Button>
      </div>
    </form>
  </>
}

export default GuestForm

// Helpers
function generateNewGuest(){
  return {
    id: ID(),
    name: '',
    occupation: '',
    email: '',
    phone: '',
    is_disabled: false,
    gender: ''
  }
}
